import { PipelinePolicy, SendRequest, PipelineRequest, PipelineResponse } from '@azure/core-rest-pipeline';
import { environment } from '../../../environments/environment';

export class AddHeadersRequestPolicy implements PipelinePolicy {

  public name = 'AddHeadersRequestPolicy';

  public sendRequest(request: PipelineRequest, next: SendRequest): Promise<PipelineResponse> {
    request.headers.set(environment.nxApi.subscriptionHeader.name, environment.nxApi.subscriptionHeader.value);
    return next(request);
  }
}
